<template>
	<h2
		v-if="isMobile && !store.isLandingPage"
		id="loginRegisterModalHeadlineId"
		tabindex="-1"
		class="z-11 absolute left-0 top-0 m-0 h-18 w-full border-b-2 border-gray-40 bg-white p-4 text-[2rem] font-semibold leading-[2.7142857rem] lg:static lg:border-b-0 lg:pt-8 lg:text-center"
	>
		<span class="mx-auto block max-w-100 lg:max-w-[unset]">{{
			$t(store.isLogin ? "login.headline" : "registration.headline")
		}}</span>
	</h2>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";
import { $t } from "@/main";

const { isMobile } = useIsMobile();
</script>
